import { useFeatureIsOn } from '@growthbook/growthbook-react';

import ModalError from '@common/containers/ModalError';

import { NotificationDialog } from './NotificationDialog';

export const GlobalErrorSurface = () => {
  const isV2 = useFeatureIsOn('feature.ecom2');

  return isV2 ? <NotificationDialog /> : <ModalError />;
};
